import { TakeEffect, takeEvery } from 'redux-saga/effects';
import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericGet } from '@/_shared/types';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_PATH_KEY } from '@/swagger/constants/anagraphics-keys';
import { API_GET_EMPLOYEES, KEY_GET_EMPLOYEES } from '../constants';
import { MOCK_RESPONSE_GET_EMPLOYEES } from '../mocks';
import { RequestEmployeesQuery } from '../types/filtersEmployees';

type FullRequestType = ReturnType<typeof createGeneralCall>['selectors']['request'] & {
  payload: Omit<CallParamsGetEmployees, 'successSaga' | 'errorSaga'>;
};

type ResponseGetEmployees = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_PATH_KEY
>['response']['body'];

export type CallParamsGetEmployees = RequestEmployeesQuery & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponseGetEmployees = ResponseGetEmployees;

type CallErrorGetEmployees = {
  message: string;
  code: number;
};

type CallSelectorsGetEmployees = {
  data: ResponseGetEmployees['data'];
  totalItems: ResponseGetEmployees['totalItems'];
  fullRequest: FullRequestType;
};

let internalPayload = {};

export const getEmployeesCall = createGeneralCall<
  CallParamsGetEmployees,
  CallResponseGetEmployees,
  CallErrorGetEmployees,
  CallSelectorsGetEmployees
>({
  id: KEY_GET_EMPLOYEES,
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_GET_EMPLOYEES(org as unknown as string, payload);
    },
  paramsSelector:
    ({ payload }) =>
    () => {
      internalPayload = { ...payload };
      return payload;
    },
  method: 'get',
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_GET_EMPLOYEES : undefined,
  selectors: {
    data: ({ selectors }) => createSelector(selectors.response, res => res?.data || []),
    totalItems: ({ selectors }) => createSelector(selectors.response, res => res?.totalItems || 0),
    fullRequest: ({ selectors }) =>
      createSelector(selectors.request, request => {
        return {
          ...request,
          payload: { ...internalPayload },
        } as unknown as FullRequestType;
      }),
  },
  cancellable: true,
  takeEffect: takeEvery as unknown as TakeEffect,
  rsmOptions: {
    doubleRun: false,
  },
});
